import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from '~shared/FluidImage'

export default function SocialImage(props) {
    const data = useStaticQuery(graphql`{
        file(relativePath: {eq: "CaseStudies/Swash/social.jpg"}) {
            childImageSharp {
                gatsbyImageData(
                    placeholder: NONE
                    layout: FULL_WIDTH
                )
            }
        }
    }`).file.childImageSharp.gatsbyImageData

    return (
        <Img
            {...props}
            data={{
                ...data,
                sizes: '(min-width: 768px) 592px, (min-width: 1200px) 1008px, 100vw',
            }}
        />
    )
}
